import { createUseStyles } from 'react-jss';
import { BadgeProps } from './';
import { Classes } from 'jss';
import { GrayscalePalette } from '@tcl-boron-colors/colors';

const smallBadge = {
  fontSize: '10px',
  fontWeight: 'bold',
  lineHeight: '10px',
  letterSpacing: '1px',
  padding: '1px 12px',
};

const bigBadge = {
  fontSize: '12px',
  fontWeight: 'bold',
  letterSpacing: '1px',
  lineHeight: '12px',
  padding: '4px 12px',
};

export const useBadgeStyles: (
  data?: BadgeProps & {
    theme?: Jss.Theme;
  },
) => Classes<'root' | 'icon'> = createUseStyles({
  root: ({ small = false, color = '', badgeType = 'primary' }: BadgeProps) => {
    const sizeSpecificStyles = small ? smallBadge : bigBadge;

    return {
      ...sizeSpecificStyles,
      backgroundColor: badgeType === 'primary' ? GrayscalePalette[100] : color,
      border: 'solid',
      borderWidth: '2px',
      borderColor: color,
      borderRadius: '4px',
      boxSizing: 'border-box',
      color: badgeType === 'primary' ? color : GrayscalePalette[100],
      display: 'inline-flex',
      flex: '0 0 min-content',
      height: 'min-content',
      textTransform: 'uppercase',
      whiteSpace: 'normal',
      width: 'min-content',
      minHeight: small ? '16px' : '24px',
      maxHeight: small ? '32px' : '40px',
    };
  },
  icon: {
    marginRight: '6px',
  },
});
